<template>
    <div class="fixed-pop">
        <div class="fixed-pop-content">
            <div @touchstart="start"
                 @touchmove="pressMove"
                 @touchend="end"
                 @mouseup="end"
                 class="PullDownClose"
                 :class="{'noPull':noPull}"
                 :style="{transform:`translateY(${getDistanceY}px)`}">
                <el-button @click="cancel()" type="text" class="close-btn" icon="el-icon-close"/>
                    <slot/>
            </div>
            <div class="fixed-pop-closed" @click="cancel()"/>
        </div>
    </div>
</template>
<script>
    export default {
        name: "PullDownClose",
        props: {
            noPull: Boolean,//不要有捲動效果
        },
        data() {
            return {
                distanceY: 0,
                clientY: 0,
                startY: 0,
                currentY: 0,
                //零界點
                point: 150,
            }
        },
        computed: {
            getDistanceY() {
                return this.distanceY
            }
        },
        created() {

        },
        mounted() {

        },
        methods: {
            //開始下拉
            start(evt) {
                this.startY = evt.clientY || evt.touches[0].clientY
            },
            pressMove(evt) {
                this.currentY = evt.clientY || evt.touches[0].clientY
                let deltaY = this.currentY - this.startY;
                //引入的內容有捲動時，往下時應該先捲動內容不下拉彈窗
                const block = document.querySelector('.PullDownClose > .content')
                let blockY = 0
                if( block ){
                    blockY = block.scrollTop
                }
                //向下
                if (deltaY  > 0 && blockY <=0  && !this.noPull) {
                    //算出彈跳的距離
                    this.distanceY += deltaY
                }
                this.startY = this.currentY
            },
            end() {
                if (this.distanceY > 0) {
                    // 当下拉到达临界点開始動作
                    if (this.distanceY >= this.point) {
                        this.$emit('close');
                        this.animation(
                            this.distanceY,
                            this.point - this.distanceY,
                            val => {
                                this.distanceY = Math.round(val)
                            },
                            () => {
                                this.animation(this.distanceY, 0 - this.distanceY, val => {
                                    this.distanceY = Math.round(val)
                                })
                            }
                        )
                    } else {
                        this.animation(this.distanceY, 0 - this.distanceY, val => {
                            this.distanceY = Math.round(val)
                        })
                    }
                }
            },
            animation(startValue, diffValue, moveIng, success) {
                let d = Math.ceil(500 / 16.7)
                let timer = null
                let t = 0
                move()
                function move() {
                    if (t > d || d === 0) {
                        cancelAnimationFrame(timer)
                        t = 0
                        success && success()
                    } else {
                        t++
                        let val = easeOutStrong(t, startValue, diffValue, d)
                        moveIng(val)
                        timer = requestAnimationFrame(move)
                    }
                }
                /*
                  t, 当前执行动画第几次
                  b, 起始值
                  c, 目标值-起始值
                  d  动画执行总次数
                  返回值： 当前次 元素应在在的一个位置
                */
                function easeOutStrong(t, b, c, d) {
                    return -c * ((t = t / d - 1) * t * t * t - 1) + b
                }
            },
            cancel() {
                // 網頁版 控制下拉視窗啟掃碼視窗
                if (!window.cordova) {
                    sessionStorage.removeItem('isShowPullDownScan');
                }

                //點空白處關閉
                this.$emit('close');
            },
        }
    }
</script>
<style lang="less" src="@/less/pullDownClose.less"/>